import React from "react";
import { useDispatch, useSelector } from "react-redux";

import CustomAlert from "../alerts/CustomAlert";

import { hideAlertDialog } from "@/redux/slices/AlertSlice";
import { RootState } from "@/redux/store";

const GlobalAlertDialog: React.FC = () => {
  const dispatch = useDispatch();
  const {
    isOpen,
    title,
    desc,
    btnName,
    cancelName,
    btnAction,
    cancelAction,
    img,
    node,
    footerElementAttr,
    showImg,
  } = useSelector((state: RootState) => state?.alert);

  const handleClose = (): void => {
    dispatch(hideAlertDialog());
  };

  return (
    <CustomAlert
      isOpen={isOpen}
      setIsOpen={handleClose}
      title={title}
      desc={desc}
      btnName={btnName}
      cancelName={cancelName}
      btnAction={btnAction}
      cancelAction={cancelAction}
      img={img}
      node={node}
      footerElementAttr={footerElementAttr}
      showImg={showImg}
    />
  );
};

export default GlobalAlertDialog;
